import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED } from "@faire/web-api--source/indigofair/settings/OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED";

export const getSettingOpenWithFaireTotalPaymentTermsGranted = () =>
  getSettingValueWithoutAssignment(
    OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED,
    IFaireMoney.build({ amount_cents: 100_000_000_00, currency: "USD" })
  );
